import * as Yup from 'yup';

export const consumerConfirmationYupValidation = () => {
  return Yup.object().shape({
    password: Yup.string().required('required'),
  });
};
